import { render, staticRenderFns } from "./Geschaeftspartnerliste.vue?vue&type=template&id=2ad1483e&"
import script from "./Geschaeftspartnerliste.vue?vue&type=script&lang=js&"
export * from "./Geschaeftspartnerliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports